import { validateResponseHasSchema } from '@/shared/api/validation'
import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import { z } from 'zod'
import { AssetType, AssetDeliveryStatus } from '@/features/assets/constants'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export const fetchAsset = (assetCode: string) => validateResponseHasSchema(
  client.sendGet(`v2/assets/${assetCode}`),
  z.object({
    data: z.object({
      code: z.string(),
      projectCode: z.number(),
      projectName: z.string(),
      type: z.nativeEnum(AssetType),
      productId: z.number(),
      deliveryStatus: z.nativeEnum(AssetDeliveryStatus),
      cumulativeYearlySavings: z.number(),
      systemSize: z.number(),
      consumptionYield: z.number(),
    })
  })
).then(r => r.data)
